import { styled } from '@clickcease/cc-client-components-lib'

export const ConnectAccountContainer = styled('div', {
  height: '450px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
})

export const PlatformButtonContainer = styled('div', {
  marginTop: '$10',
  marginBottom: '$8',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: '$10',
})

export const MiddleTextMargins = styled('div', {
  marginTop: '$6',
  marginBottom: '$2',
})

export const ConnectionOption = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '320px',
  height: '100px',
  padding: '$10',
  border: '1px solid $lightNeutral',
  borderRadius: '12px',
  background: '$white',
  cursor: 'pointer',
  boxShadow: '0px 0px 30px 0px rgba(102, 102, 102, 0.05)',

  '&:hover': {
    border: '1px solid $buttonHovered',
  },

  variants: {
    selected: {
      true: {
        border: '1px solid $buttonPressed',
      },
    },
  },
})

export const NewLine = styled('span', {
  display: 'block',
  variants: {
    bigSpace: {
      true: {
        marginBottom: '$5',
      },
    },
  },
})
